import dayjs from 'dayjs';
import toObject from 'dayjs/plugin/toObject';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import objectSupport from 'dayjs/plugin/objectSupport';
dayjs.extend(customParseFormat);
dayjs.extend(toObject);
dayjs.extend(objectSupport);
import { DEFAULT_DATE_FORMAT as DATE_FORMAT } from './constants';
export function getDay() {
  return dayjs().date();
}
export var getTodayObject = function getTodayObject() {
  return dayjs().startOf('day').toObject();
};
var getDecadeBegin = function getDecadeBegin(d) {
  var y = d.getFullYear ? d.getFullYear() : d.years;
  var ld = y % 10;
  if (ld === 0) {
    return y - 9;
  } else {
    return y - ld + 1;
  }
};
export function startOf(unit, date) {
  if (unit === 'decade') {
    return new Date(getDecadeBegin(date), 0, 1);
  }
  return dayjs(date).startOf(unit).toObject();
}
export function endOf(unit, date) {
  return dayjs(date).endOf(unit).toObject();
}
export function isSame(originDate, compareDate, unit) {
  if (unit === void 0) {
    unit = 'day';
  }
  return dayjs(originDate, typeof originDate === 'string' ? DATE_FORMAT : undefined).isSame(dayjs(compareDate, typeof compareDate === 'string' ? DATE_FORMAT : undefined), unit);
}
export function manipulate(date, operation, unit, step) {
  if (step === void 0) {
    step = 1;
  }
  var _unit = unit;
  if (_unit === 'month') {
    _unit = 'months';
  } else if (_unit === 'year') {
    _unit = 'years';
  }
  var _date = date;
  var _step = step;
  if (_unit === 'decade') {
    _date = startOf('decade', _date);
    _unit = 'years';
    if (_step === 1) {
      _step = _step * 10;
    }
  }
  if (!date._isAMomentObject) {
    _date = dayjs(_date);
  }
  if (operation === 'add') {
    return _date.add(_step, _unit).toObject();
  } else if (operation === 'subtract') {
    return _date.subtract(_step, _unit).toObject();
  } else {
    return getTodayObject();
  }
}
export function checkWithMinMax(view, date, minDate, maxDate) {
  if (view === 'month') {
    if (minDate) {
      date = date.getTime() < minDate.getTime() ? minDate : date;
    }
    if (maxDate) {
      date = date.getTime() > maxDate.getTime() ? maxDate : date;
    }
  }
  return date;
}
export function isInSameDecade(date1, date2) {
  return getDecadeBegin(date1) === getDecadeBegin(date2);
}
export function isInSameViewPage(date1, date2, view) {
  return view === 'decade' ? date1 && date2 && isInSameDecade(date1, date2) : date1 && date2 && isSame(date1, date2, view);
}
export function moveToNextDate(e, view, selectValue, keyboardNavDate, activeStartDate, minDate, maxDate) {
  var convertTable = new Map();
  convertTable.set('month', 'day');
  convertTable.set('year', 'month');
  convertTable.set('decade', 'year');
  var verticalTable = new Map();
  verticalTable.set('month', 7);
  verticalTable.set('year', 3);
  verticalTable.set('decade', 3);

  //handle 4 four direction
  var isDown = e.key === 'ArrowDown';
  var isUp = e.key === 'ArrowUp';
  var isLeft = e.key === 'ArrowLeft';
  var operator = isLeft || isUp ? 'subtract' : 'add';
  var unit = isDown || isUp ? verticalTable.get(view) : 1;
  var bisInSameViewPage = isInSameViewPage(selectValue, activeStartDate, view);

  //need to reset
  if (!keyboardNavDate && !(bisInSameViewPage && selectValue)) {
    keyboardNavDate = activeStartDate;
    return {
      keyboardNavDate: keyboardNavDate,
      activeStartDate: activeStartDate
    };
  }
  keyboardNavDate = manipulate(keyboardNavDate || selectValue, operator, convertTable.get(view), unit);
  keyboardNavDate = startOf(convertTable.get(view), keyboardNavDate);
  keyboardNavDate = dayjs(keyboardNavDate).toDate();
  keyboardNavDate = checkWithMinMax(view, keyboardNavDate, minDate, maxDate);

  //special handle for decade
  var endDay;
  var isDecade = view === 'decade';
  if (isDecade) {
    endDay = manipulate(activeStartDate, 'add', 'year', 12);
  } else {
    endDay = endOf(convertTable.get(view), activeStartDate);
  }
  endDay = dayjs(endDay).toDate();

  //adjust activeStartDate if needed
  if (keyboardNavDate.getTime() < activeStartDate.getTime()) {
    if (isDecade) {
      activeStartDate = manipulate(activeStartDate, 'subtract', 'year', 12);
    } else {
      activeStartDate = startOf(view, keyboardNavDate);
    }
    activeStartDate = dayjs(activeStartDate).toDate();
  } else if (keyboardNavDate.getTime() > endDay.getTime()) {
    if (isDecade) {
      activeStartDate = manipulate(activeStartDate, 'add', 'year', 12);
    } else {
      activeStartDate = startOf(view, keyboardNavDate);
    }
    activeStartDate = dayjs(activeStartDate).toDate();
  }
  return {
    keyboardNavDate: keyboardNavDate,
    activeStartDate: activeStartDate
  };
}

// e.g
// M T W T F S S
//     1 2 3 4 5
// 6 7 8 9 10 11 12
export function getDateMatrix(activeStartDate, view, firstDayOfWeek) {
  if (firstDayOfWeek === void 0) {
    firstDayOfWeek = 0;
  }
  var result = [],
    unit = 'day';
  if (view === 'month') {
    var currentMonth = activeStartDate.getMonth();
    var tempD = activeStartDate;
    var row = [];
    while (tempD.getMonth() === currentMonth) {
      row.push(tempD);
      if ((tempD.getDay() + 1) % 7 === firstDayOfWeek) {
        result.push(row);
        row = [];
      }
      //++1
      tempD = manipulate(tempD, 'add', 'day');
      tempD = dayjs(tempD).toDate();
    }
    if (row.length > 0) {
      result.push(row);
    }
  } else if (view === 'year') {
    unit = 'month';
    var currentYear = activeStartDate.getFullYear();
    var _row = [];
    for (var ii = 0; ii < 12; ii++) {
      var _tempD = new Date(currentYear, ii, 1);
      _row.push(_tempD);
      if ((ii + 1) % 3 === 0) {
        result.push(_row);
        _row = [];
      }
    }
    if (_row.length > 0) {
      result.push(_row);
    }
  } else if (view === 'decade') {
    unit = 'year';
    var _currentYear = activeStartDate.getFullYear();
    var _row2 = [];
    for (var _ii = 0; _ii < 12; _ii++) {
      var _tempD2 = new Date(_currentYear + _ii, 0, 1);
      _row2.push(_tempD2);
      if ((_ii + 1) % 3 === 0) {
        result.push(_row2);
        _row2 = [];
      }
    }
    if (_row2.length > 0) {
      result.push(_row2);
    }
  }
  //a function for result
  result.findIndex = function (date) {
    var index;
    result.forEach(function (row, ii) {
      row.forEach(function (d, jj) {
        if (isSame(d, date, unit)) {
          index = [ii, jj];
        }
      });
    });
    return index;
  };
  return result;
}